import React from "react";
import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import LogoListUi from "../../ui/LogoList";
import { LogoListBlock } from "../../lib/storyblok/types/blocks/LogoListBlock";
import StoryblokImage from "../StoryblokImage";
import useMediaQuery from "../../hooks/useMatchMedia";
import { isValidImageData } from "../../lib/utils/imageUtils";

const { List } = LogoListUi;

const LogoList: StoryblokBlockComponent<
  LogoListBlock & { heroArea?: boolean }
> = ({
  title,
  description,
  logos,
  headingSize,
  logoSize,
  logoOpacity,
  scrollOnDesktop,
  spacing,
  transparentLogoBackground,
  logoStyle,
  heroArea,
}) => {
  const isMobile = useMediaQuery("(max-width: 1024px)");
  const shouldScroll = isMobile || scrollOnDesktop;

  const transformedLogos =
    logos?.map((logo) => ({
      _uid: logo._uid,
      imageElement: isValidImageData(logo.logo) && (
        <StoryblokImage
          image={logo.logo}
          layout="fill"
          sizes="100vw"
          resize={{ width: 256 }}
          objectFit="contain"
          alt={logo.logo.alt}
        />
      ),
    })) || [];

  return (
    <LogoListUi
      title={title}
      description={description}
      spacing={spacing}
      headingSize={headingSize}
      heroArea={heroArea}
    >
      <List
        shouldScroll={shouldScroll}
        isMobile={isMobile}
        logos={transformedLogos}
        logoSize={logoSize}
        transparent={transparentLogoBackground}
        logoStyle={logoStyle}
        logoOpacity={logoOpacity?.value ? logoOpacity.value / 100 : 1}
      />
    </LogoListUi>
  );
};

export default LogoList;
